/**
 * 消息提示框
 * 公用方法
 * @author fulh 2014年1月14日 11:48:42
 *
 * alert  :信息提示基础方法
 * close  :关闭提示
 * loading:加载提示
 * warn   :警告提示
 * success:成功提示
 * error  :错误提示
 */
$.module('MM.ui.toast', function () {
  var tmplWrap = '<div class="ui-toast"></div>';
  var tmplItem = '<div class="ui-toast-item"><%= text %></div>';

  var $wrap = null;
  var currentBottom = 0;

  function _show(text) {
    if (!$wrap) {
      $wrap = $(tmplWrap);
      $('body').append($wrap);
    }
    currentBottom = currentBottom < 0 ? 0 : currentBottom;

    var $item = $($.template(tmplItem, { text: text })).css(
      'bottom',
      currentBottom,
    );

    $wrap.prepend($item);

    currentBottom += 58;

    $item.effect('fadeInDown');

    var close = (function ($dom, bottom) {
      return function () {
        $dom.effect('fadeOutDown', function () {
          $dom.remove();
          if (currentBottom === bottom) {
            currentBottom = 0;
          }
        });
      };
    })($item, currentBottom);

    setTimeout(close, 3000);
  }

  return {
    show: _show,
  };
});
